import { Button } from "reactstrap";
import { FaBars, FaLeftLong, FaLeftRight } from "react-icons/fa6";
import { useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "../../languages";

const MainNavigatorTab = ({
  items,
  flowAt,
  setFlowAt,
  children,
  onItemClick,
}) => {
  const [isOpen, setisOpen] = useState(true);
  const { t } = useTranslation();
  return (
    <div className="white-nav-tab gap-md-3 p-2 p-md-0  flex-md-nowrap d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center gap-2">
        {items?.map((item, key) => {
          return (
            <button
              key={key}
              onClick={() => {
                setFlowAt(item?.flowAt);
                if (onItemClick) {
                  onItemClick(item);
                }
              }}
              className={`${flowAt === item?.flowAt ? "active" : ""} px-2`}
            >
              {t(item?.title)}
            </button>
          );
        })}
      </div>

      {children && (
        <>
          <div
            className="d-md-none  d-block"
            onClick={() => setisOpen((prev) => !prev)}
          >
            {" "}
            {!isOpen ? <RxHamburgerMenu size={20} /> : <RxCross2 size={20} />}
          </div>

          <div
            style={{ transform: isOpen ? "" : "scale(0,0)" }}
            className={`white-nav-tab-children  d-flex  flex-column flex-md-row align-items-md-center  p-0 justify-content-md-end`}
          >
            {children}
          </div>
        </>
      )}
    </div>
  );
};

export default MainNavigatorTab;
